import * as React from 'react';
import { Layout } from 'components/Layout';
import { HeroJob } from 'components/HeroJob';
import { Stack } from '@lcifr/components/stack';
import { Box } from '@lcifr/components/box';
import { Wrap } from '@lcifr/components/wrap';
import { PortableNodes } from '@lcifr/components/lib/portable-nodes/component';
import { RelatedArticles } from 'components/RelatedArticles';
import { usePortableSections } from '@lcifr/components/portable-sections';

export type JobProps = {
  pageData: any;
};

export default function Job({ pageData }: JobProps) {
  const footer = (pageData as any)?.pageDocument?.page?.footer;
  const header = {
    ...(pageData as any)?.i18n?.header,
    hasNoTopBackground: true,
  };
  const socialProfiles = (pageData as any)?.i18n?.socialProfiles;
  const PortableSections = usePortableSections();
  return (
    <Layout header={header} footer={footer} socialProfiles={socialProfiles}>
      <HeroJob pageId={pageData?.pageDocument?._id} />
      {pageData?.pageDocument?.content ? (
        <Wrap>
          <PortableSections blocks={pageData?.pageDocument?.content}>
            {(children) => <Stack space={6}>{children}</Stack>}
          </PortableSections>
        </Wrap>
      ) : (
        <Box
          sx={{
            minHeight: 300,
          }}
        />
      )}
    </Layout>
  );
}
